import axios from 'axios';

export default {
  getCompanyBranding
};

async function getCompanyBranding() {
  try {
    const result = await axios.get('/v1.1/metadata/companybranding');
    return result.data;
  } catch (e) {
    console.error('[API] Failed to get company branding:', e);
    return null;
  }
}
